import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateGarageCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const propertyIdentificationForTransaction = propertyIdentification[id];

  if (!improvementsForTransaction || !propertyIdentificationForTransaction) {
    return undefined;
  }

  const {
    garage,
    craftsmanQuality: quality,
    propertyType = 'singleFamilyResidence',
  } = improvementsForTransaction;

  if (!garage || !ORDER_FEATURES.garage.hasFeature(improvementsForTransaction)) return undefined;

  const {
    address: { PostalCode: zipCode },
  } = propertyIdentificationForTransaction;

  if (isUndefined(quality) || (quality * 10) % 1 !== 0 || quality < 1 || isUndefined(zipCode)) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getGarageCost({
    sqft: AloftArea.schema.parse(garage.area),
    garageType: 'attached',
    zipCode,
    quality: garage.quality ?? quality,
    propertyType,
  });
};

export const {
  selectGarageCost,
  selectZipOnlyGarageCost,
  selectGarageCosts,
  selectGarageCostDisplay,
} = createFeatureCostSelectors({
  calculate: calculateGarageCost,
  inputSelectors: [
    selectCostProps,
    selectImprovementsEntities,
    selectPropertyIdentificationEntities,
  ],
  names: {
    cost: 'selectGarageCost',
    zipOnly: 'selectZipOnlyGarageCost',
    costs: 'selectGarageCosts',
    display: 'selectGarageCostDisplay',
  },
});
